export const GET_STUDENTS = "GET_STUDENTS";
export const GET_PROFESORS = "GET_PROFESORS";
export const GET_MATERIAS = "GET_MATERIAS";
export const GET_MATERIAS_BY_ID = "GET_MATERIAS_BY_ID";
export const GET_MATERIAS_BY_NAME = "GET_MATERIAS_BY_NAME";
export const GET_AULAS = "GET_AULAS";
export const CLEAN_DETAIL = "CLEAN_DETAIL";
export const POST_ALUMNO = "POST_ALUMNO";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_ERROR = "LOGOUT_ERROR";
export const VERIFY_USER_SUCCESS = "VERIFY_USER_SUCCESS";
export const VERIFY_USER_ERROR = "VERIFY_USER_ERROR";
export const GET_USER_DATA_GOOGLE = "GET_USER_DATA_GOOGLE";
export const GET_MATERIAS_BY_ANIO = "GET_MATERIAS_BY_ANIO";
export const SET_USER_ROLE = "SET_USER_ROLE";
export const CLEAR_USER_ROLE = "CLEAR_USER_ROLE";
export const POST_PROFESOR = "POST_PROFESOR";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const EDIT_ALUMNO = "EDIT_ALUMNO";
export const CLEAN_RESPONSE = "CLEAN_RESPONSE";
export const POST_PROFESOR_DE_BAJA = "POST_PROFESOR_DE_BAJA";
export const POST_ALUMNO_DE_BAJA = "POST_ALUMNO_DE_BAJA";
export const DELETE_ALUMNO = "DELETE_ALUMNO";
export const DELETE_PROFESOR = "DELETE_PROFESOR";
export const EDIT_ALUMNO2 = "EDIT_ALUMNO2";
export const EDIT_PROFESOR = "EDIT_PROFESOR";
export const DELETE_MATERIAS = "DELETE_MATERIA";
export const GET_MATERIAS_ADMIN = "GET_MATERIAS_ADMIN";
